import { useRecordContext } from 'react-admin'
import {
  Box,
  CardHeader,
  List as ListMui,
  ListItem,
  ListItemText,
  Paper,
} from '@material-ui/core'

export const InformationsImportant = (props) => {
  const record = useRecordContext(props)
  if (!record) return null
  return (
    <Box component={Paper}>
      <CardHeader title="Informations Importantes" />
      <ListMui>
        <ListItem>
          <ListItemText
            primary="Adresse"
            secondary={record.fiche_complement_adresse || 'Non applicable'}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Votre code d’acces"
            secondary={record.fiche_codes_acces || 'Non applicable'}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Le Rib de votre Copropriete"
            secondary={record.fiche_rib_compte_courant || 'Non applicable'}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Date de votre dernière AG"
            secondary={record.fiche_date_ag_n1 || 'Non applicable'}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Code Copropriété"
            secondary={record.fiche_code || 'Non applicable'}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Contact CS"
            secondary={record.fiche_email_contact || 'Non applicable'}
          />
        </ListItem>
      </ListMui>
    </Box>
  )
}
